import React from 'react';

export const formatINR = (value) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(Number(value) || 0);

/** Compact ₹ formatter. */
const Money = ({ value, className = '' }) => (
  <span className={className}>{formatINR(value)}</span>
);

export default Money;
